module.exports = {
  id: 42,
  name: 'Single-Leg Squats',
  categories: ['strength', 'legs', 'balance', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Strength',
  points: 23,
  instructions:
    'Single-leg squats are challenging! Stand on one leg and squat down, keeping your other leg off the ground! This builds incredible leg strength and balance!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready for single-leg squats? Let us build incredible leg strength and balance!',
    },
    {
      time: 3,
      text: 'Stand on your right leg, keep your balance! Fantastic form!',
    },
    {
      time: 6,
      text: 'Make sure to keep your other leg off the ground and core engaged, feeling the strength in your stomach muscles!',
    },
    {
      time: 9,
      text: "Next, squat down slowly! It's very important that you do this slow and controlled. This is the most important part of the exercise.",
    },
    // SET 1 - 10 reps right leg
    {
      time: 12,
      text: 'Ok, now that you know how to do it, let us begin the workout! Stand on your right leg!',
    },
    {
      time: 15,
      text: 'Number 1! Squat down slowly, slow, slow, slow! ',
    },
    {
      time: 18,
      text: 'Stand back up still balancing on your right leg with control, stay balanced!',
    },
    {
      time: 21,
      text: 'Number 2! Squat down slowly, keep your core engaged!',
    },
    {
      time: 24,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 27,
      text: 'Number 3! Squat down slowly, keep your balance!',
    },
    {
      time: 30,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 33,
      text: 'Number 4! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 36,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 39,
      text: 'Number 5! Squat down slowly, keep your core engaged!',
    },
    {
      time: 42,
      text: 'Stand back up with control, keep going!',
    },
    {
      time: 45,
      text: 'Number 6! Squat down slowly, keep your balance!',
    },
    {
      time: 48,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 51,
      text: 'Number 7! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 54,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 57,
      text: 'Number 8! Squat down slowly, keep your core engaged!',
    },
    {
      time: 60,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 63,
      text: 'Number 9! Squat down slowly, keep your balance!',
    },
    {
      time: 66,
      text: 'Stand back up with control, almost there!',
    },
    {
      time: 69,
      text: 'Number 10! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 72,
      text: 'Stand back up with control, incredible work!',
    },
    {
      time: 75,
      text: 'Great job! Now switch to your left leg!',
    },
    // REST PERIOD 1 - 30 seconds
    {
      time: 78,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 81,
      text: 'Shake out your legs and get ready for your left leg!',
    },
    {
      time: 84,
      text: 'You are doing amazing! Ready for your left leg? Let us keep going!',
    },
    {
      time: 87,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 1 - 10 reps left leg
    {
      time: 90,
      text: 'Stand on your left leg, keep your balance!',
    },
    {
      time: 93,
      text: 'Keep your other leg off the ground and core engaged!',
    },
    {
      time: 96,
      text: 'Perfect balance position! Squat down slowly!',
    },
    {
      time: 99,
      text: 'Number 1! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 102,
      text: 'Stand back up with control, stay balanced!',
    },
    {
      time: 105,
      text: 'Number 2! Squat down slowly, keep your core engaged!',
    },
    {
      time: 108,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 111,
      text: 'Number 3! Squat down slowly, keep your balance!',
    },
    {
      time: 114,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 117,
      text: 'Number 4! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 120,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 123,
      text: 'Number 5! Squat down slowly, keep your core engaged!',
    },
    {
      time: 126,
      text: 'Stand back up with control, keep going!',
    },
    {
      time: 129,
      text: 'Number 6! Squat down slowly, keep your balance!',
    },
    {
      time: 132,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 135,
      text: 'Number 7! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 138,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 141,
      text: 'Number 8! Squat down slowly, keep your core engaged!',
    },
    {
      time: 144,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 147,
      text: 'Number 9! Squat down slowly, keep your balance!',
    },
    {
      time: 150,
      text: 'Stand back up with control, almost there!',
    },
    {
      time: 153,
      text: 'Number 10! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 156,
      text: 'Stand back up with control, incredible work!',
    },
    {
      time: 159,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 30 seconds
    {
      time: 162,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 165,
      text: 'Shake out your legs and get ready for round two!',
    },
    {
      time: 168,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 171,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 10 reps right leg
    {
      time: 174,
      text: 'Stand on your right leg, keep your balance!',
    },
    {
      time: 177,
      text: 'Keep your other leg off the ground and core engaged!',
    },
    {
      time: 180,
      text: 'Perfect balance position! Squat down slowly!',
    },
    {
      time: 183,
      text: 'Number 1! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 186,
      text: 'Stand back up with control, stay balanced!',
    },
    {
      time: 189,
      text: 'Number 2! Squat down slowly, keep your core engaged!',
    },
    {
      time: 192,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 195,
      text: 'Number 3! Squat down slowly, keep your balance!',
    },
    {
      time: 198,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 201,
      text: 'Number 4! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 204,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 207,
      text: 'Number 5! Squat down slowly, keep your core engaged!',
    },
    {
      time: 210,
      text: 'Stand back up with control, keep going!',
    },
    {
      time: 213,
      text: 'Number 6! Squat down slowly, keep your balance!',
    },
    {
      time: 216,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 219,
      text: 'Number 7! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 222,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 225,
      text: 'Number 8! Squat down slowly, keep your core engaged!',
    },
    {
      time: 228,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 231,
      text: 'Number 9! Squat down slowly, keep your balance!',
    },
    {
      time: 234,
      text: 'Stand back up with control, almost there!',
    },
    {
      time: 237,
      text: 'Number 10! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 240,
      text: 'Stand back up with control, incredible work!',
    },
    {
      time: 243,
      text: 'Great job! Now switch to your left leg!',
    },
    // REST PERIOD 3 - 30 seconds
    {
      time: 246,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 249,
      text: 'Shake out your legs and get ready for your left leg!',
    },
    {
      time: 252,
      text: 'You are doing amazing! Ready for your left leg? Let us keep going!',
    },
    {
      time: 255,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 10 reps left leg
    {
      time: 258,
      text: 'Stand on your left leg, keep your balance!',
    },
    {
      time: 261,
      text: 'Keep your other leg off the ground and core engaged!',
    },
    {
      time: 264,
      text: 'Perfect balance position! Squat down slowly!',
    },
    {
      time: 267,
      text: 'Number 1! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 270,
      text: 'Stand back up with control, stay balanced!',
    },
    {
      time: 273,
      text: 'Number 2! Squat down slowly, keep your core engaged!',
    },
    {
      time: 276,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 279,
      text: 'Number 3! Squat down slowly, keep your balance!',
    },
    {
      time: 282,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 285,
      text: 'Number 4! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 288,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 291,
      text: 'Number 5! Squat down slowly, keep your core engaged!',
    },
    {
      time: 294,
      text: 'Stand back up with control, keep going!',
    },
    {
      time: 297,
      text: 'Number 6! Squat down slowly, keep your balance!',
    },
    {
      time: 300,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 303,
      text: 'Number 7! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 306,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 309,
      text: 'Number 8! Squat down slowly, keep your core engaged!',
    },
    {
      time: 312,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 315,
      text: 'Number 9! Squat down slowly, keep your balance!',
    },
    {
      time: 318,
      text: 'Stand back up with control, almost there!',
    },
    {
      time: 321,
      text: 'Number 10! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 324,
      text: 'Stand back up with control, incredible work!',
    },
    {
      time: 327,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 4 - 30 seconds
    {
      time: 330,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 333,
      text: 'Shake out your legs and get ready for the final round!',
    },
    {
      time: 336,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 339,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 10 reps right leg
    {
      time: 342,
      text: 'Stand on your right leg, keep your balance!',
    },
    {
      time: 345,
      text: 'Keep your other leg off the ground and core engaged!',
    },
    {
      time: 348,
      text: 'Perfect balance position! Squat down slowly!',
    },
    {
      time: 351,
      text: 'Number 1! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 354,
      text: 'Stand back up with control, stay balanced!',
    },
    {
      time: 357,
      text: 'Number 2! Squat down slowly, keep your core engaged!',
    },
    {
      time: 360,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 363,
      text: 'Number 3! Squat down slowly, keep your balance!',
    },
    {
      time: 366,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 369,
      text: 'Number 4! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 372,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 375,
      text: 'Number 5! Squat down slowly, keep your core engaged!',
    },
    {
      time: 378,
      text: 'Stand back up with control, keep going!',
    },
    {
      time: 381,
      text: 'Number 6! Squat down slowly, keep your balance!',
    },
    {
      time: 384,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 387,
      text: 'Number 7! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 390,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 393,
      text: 'Number 8! Squat down slowly, keep your core engaged!',
    },
    {
      time: 396,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 399,
      text: 'Number 9! Squat down slowly, keep your balance!',
    },
    {
      time: 402,
      text: 'Stand back up with control, almost there!',
    },
    {
      time: 405,
      text: 'Number 10! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 408,
      text: 'Stand back up with control, incredible work!',
    },
    {
      time: 411,
      text: 'Great job! Now switch to your left leg!',
    },
    // REST PERIOD 5 - 30 seconds
    {
      time: 414,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 417,
      text: 'Shake out your legs and get ready for your left leg!',
    },
    {
      time: 420,
      text: 'You are doing amazing! Ready for your left leg? Let us finish strong!',
    },
    {
      time: 423,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 10 reps left leg
    {
      time: 426,
      text: 'Stand on your left leg, keep your balance!',
    },
    {
      time: 429,
      text: 'Keep your other leg off the ground and core engaged!',
    },
    {
      time: 432,
      text: 'Perfect balance position! Squat down slowly!',
    },
    {
      time: 435,
      text: 'Number 1! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 438,
      text: 'Stand back up with control, stay balanced!',
    },
    {
      time: 441,
      text: 'Number 2! Squat down slowly, keep your core engaged!',
    },
    {
      time: 444,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 447,
      text: 'Number 3! Squat down slowly, keep your balance!',
    },
    {
      time: 450,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 453,
      text: 'Number 4! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 456,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 459,
      text: 'Number 5! Squat down slowly, keep your core engaged!',
    },
    {
      time: 462,
      text: 'Stand back up with control, keep going!',
    },
    {
      time: 465,
      text: 'Number 6! Squat down slowly, keep your balance!',
    },
    {
      time: 468,
      text: 'Stand back up with control, you are doing great!',
    },
    {
      time: 471,
      text: 'Number 7! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 474,
      text: 'Stand back up with control, stay focused!',
    },
    {
      time: 477,
      text: 'Number 8! Squat down slowly, keep your core engaged!',
    },
    {
      time: 480,
      text: 'Stand back up with control, you are strong!',
    },
    {
      time: 483,
      text: 'Number 9! Squat down slowly, keep your balance!',
    },
    {
      time: 486,
      text: 'Stand back up with control, almost there!',
    },
    {
      time: 489,
      text: 'Number 10! Squat down slowly, keep your other leg off the ground!',
    },
    {
      time: 492,
      text: 'Stand back up with control, incredible work!',
    },
    {
      time: 495,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 498,
      text: 'Amazing work! You did 60 single-leg squats and built incredible leg strength!',
    },
    {
      time: 501,
      text: 'Your leg strength and balance are getting super strong! You are a squat master!',
    },
    {
      time: 504,
      text: 'Great job, strength champion! You are building incredible power!',
    },
  ],
};
